function sanitizeDriversForApi(drivers: Record<string, any> | null | undefined): Record<string, any> | undefined {
	if (!drivers) return undefined;
	const next: Record<string, any> = {};
	Object.entries(drivers).forEach(([key, d]) => {
		if (!d) return;
		const src = String(d.src || '').toLowerCase();
		if (!d.isNew && src === 'formula' && !String(d.formula || '').trim()) return;

		const clean = { ...d, src };
		if (src === 'input' || src === 'binding' || src === 'fitted' || src === 'rollup') {
			clean.formula = '';
		}
		const overwrite = src === 'input' ? String(clean.overwrite || '').trim() : '';
		if (overwrite) clean.overwrite = overwrite;
		else delete clean.overwrite;
		if (clean.rollup != null) clean.rollup = String(clean.rollup).trim();
		if (clean.totalsMode) {
			const mode = String(clean.totalsMode).toLowerCase();
			clean.totalsMode = mode === 'formula' || mode === 'no_totals' ? mode : 'add_up';
			clean.totalsFormula = clean.totalsMode === 'formula' ? String(clean.totalsFormula || '').trim() : '';
		}
		delete clean.agg;
		delete clean.weight;
		next[key] = clean;
	});
	return Object.keys(next).length ? next : undefined;
}

export { sanitizeDriversForApi };
